import React, { useEffect, useState } from "react";
import product_default from "../../../../assets/product_default.png";
import "./MyordersPage.css";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { check } from "../../../comman/components/CommonimagePath";
import { getRequestcall } from "../../../comman/util/getRequest";
import { ORDER_DETAIL } from "../../../constants/apiurl";
import { Card } from "react-bootstrap/esm";

function OrderDatails(props) {
  const [orderDetail, setOrderDetail] = useState({});
  const { t } = useTranslation();
  const [load, setLoad] = useState(true);
  const orderStatus = [
    {
      orderstatus: "Accepted",
      orderstatus_tr: "Kabul edilmiş",
    },
    {
      orderstatus: "Packed",
      orderstatus_tr: "Paketlenmiş",
    },
    {
      orderstatus: "Dispatched",
      orderstatus_tr: "Sevk edilen",
    },
    {
      orderstatus: "Delivered",
      orderstatus_tr: "Teslim edilmiş",
    },
    {
      orderstatus: "Cancelled",
      orderstatus_tr: "İptal edildi",
    },
  ];

  useEffect(() => {
    callOrderdetails();
    // eslint-disable-next-line
  }, [props.item]);

  const callOrderdetails = async () => {
    setLoad(true);
    let apiurl = ORDER_DETAIL + `/${props?.item?.id}`;
    let getResponsecall = await getRequestcall(apiurl, props?.access_token);
    if (getResponsecall?.status === 200) {
      const resultDetail = await getResponsecall.json();
      setOrderDetail(resultDetail?.data);
    }
    setLoad(false);
  };

  if (load) {
    return (
      <div className="detail_spinner">
        <div className="spinner_card">
          <div className="cover skeleton">
            <LazyLoadImage id={"cover"} alt={""} />
          </div>
          <div className="content_skeleton">
            <div className="content pl-3">
              <small id="subtitle" className="skeleton"></small>
              <label id="title" className="skeleton"></label>
            </div>
            <div className="content button">
              <button id="subtitle" className="skeleton"></button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return orderDetail?.products?.map((item, index) => (

<>

<Card className="p-0 flex-column mob-product-list">
                 <Card>
                 <Card.Img src={
                item?.product_image_url
                  ? item?.product_image_url
                  : product_default
              }   onError={(event) => {
                event.target.src = product_default;
              }}/>
                 <Card.Body>
                    <div>
                        <h5>
                        {props.language === "Tr"
                  ? item?.title_in_tr
                  : item?.product_name}
                        </h5>
                        <label>
                        {t("pages.myorders.seller")}:
                        </label>
                        <h5>
                        {orderDetail?.store_name}
                        </h5>
                    </div>
                 </Card.Body>
                 </Card>
                  <div className="order-detail">
                     <div>
                     <label>{t("pages.myorders.qty")}</label>
                     <div>
                     <h5>{item?.quantity}</h5>
                     </div>
                     </div>
                     <div>
                     <label>{t("pages.myorders.totalbill")}</label>
                     <h5>{Number(item?.sub_total).toFixed(2)}
                {process.env.REACT_APP_CURRENCY_SYMBOL}</h5>
                     </div>
                     <div>
                     <label>{orderStatus.map((value, index) =>
                      value.orderstatus === orderDetail.order_status ? (
                        props.language === "Tr" ? (
                          value.orderstatus_tr
                        ) : (
                          orderDetail.order_status
                        )
                      ) : (
                        <></>
                      )
                    )}</label>
                     <div className="steppers-1">
                  <label className="stepper_icon">
                    <img src={check} height="20" width="20" alt="steps"></img>
                  </label>
                </div>
                     </div>
                  </div>  
                </Card>

                <div key={index.toString()} className="col-12 order_list">
      <div className="card ">
        <div className="card-body">
          <div className="order_items">
            <LazyLoadImage
              className="order_image"
              alt=""
              onError={(event) => {
                event.target.src = product_default;
              }}
              src={
                item?.product_image_url
                  ? item?.product_image_url
                  : product_default
              }
            ></LazyLoadImage>
            <div className="product_detail">
              <h5 className="pro_name primary-text ">
                {props.language === "Tr"
                  ? item?.title_in_tr
                  : item?.product_name}
              </h5>
              <label className="secoundary-text">
                {t("pages.myorders.seller")}:
                <span className="w400 primary-text">
                  {" "}
                  {orderDetail?.store_name}
                </span>
              </label>
            </div>
          </div>
          <div className="order_qty">
            {t("pages.myorders.qty")}:{" "}
            <label className="qty">{item?.quantity}</label>
          </div>
          <div className="order_billing">
            <div className="order_price">
              {t("pages.Price")}:{" "}
              <strong>
                {Number(item?.sub_total).toFixed(2)}
                {process.env.REACT_APP_CURRENCY_SYMBOL}
              </strong>
            </div>
            <div className="stepper">
              <div className="stepper_div">
                <div className="steppers-1">
                  <label className="stepper_icon">
                    <img src={check} height="20" width="20" alt="steps"></img>
                  </label>
                </div>
                <div className="steppers-2">
                  <h5 className="placed">
                    {orderStatus.map((value, index) =>
                      value.orderstatus === orderDetail.order_status ? (
                        props.language === "Tr" ? (
                          value.orderstatus_tr
                        ) : (
                          orderDetail.order_status
                        )
                      ) : (
                        <></>
                      )
                    )}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



</>


  ));
}

const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
});

export default connect(mapStateToProps)(OrderDatails);
